// section 1

export const exporteEntityInfokeys = {
    EXPORTER_ENTITY_INFO_QUESTION_1: 'exporterEntityInfoQuestion1',
    EXPORTER_ENTITY_INFO_QUESTION_2: 'exporterEntityInfoQuestion2',
    EXPORTER_ENTITY_INFO_QUESTION_3: 'exporterEntityInfoQuestion3',
    EXPORTER_ENTITY_INFO_QUESTION_4: 'exporterEntityInfoQuestion4',
    EXPORTER_ENTITY_INFO_QUESTION_5: 'exporterEntityInfoQuestion5',
    EXPORTER_ENTITY_INFO_QUESTION_6: 'exporterEntityInfoQuestion6',
    EXPORTER_ENTITY_INFO_QUESTION_7: 'exporterEntityInfoQuestion7',
    EXPORTER_ENTITY_INFO_QUESTION_8: 'exporterEntityInfoQuestion8',
    EXPORTER_ENTITY_INFO_QUESTION_9: 'exporterEntityInfoQuestion9',
    EXPORTER_ENTITY_INFO_QUESTION_10: 'exporterEntityInfoQuestion10',
    EXPORTER_ENTITY_INFO_QUESTION_11: 'exporterEntityInfoQuestion11',
    EXPORTER_ENTITY_INFO_QUESTION_12: 'exporterEntityInfoQuestion12',
    EXPORTER_ENTITY_INFO_QUESTION_13: 'exporterEntityInfoQuestion13',
    EXPORTER_ENTITY_INFO_QUESTION_14: 'exporterEntityInfoQuestion14',
    EXPORTER_ENTITY_INFO_QUESTION_15: 'exporterEntityInfoQuestion15',
    EXPORTER_ENTITY_INFO_QUESTION_16: 'exporterEntityInfoQuestion16',
    EXPORTER_ENTITY_INFO_QUESTION_17: 'exporterEntityInfoQuestion17',
    EXPORTER_ENTITY_INFO_QUESTION_18: 'exporterEntityInfoQuestion18',
    EXPORTER_ENTITY_INFO_QUESTION_19: 'exporterEntityInfoQuestion19',
    EXPORTER_ENTITY_INFO_QUESTION_20: 'exporterEntityInfoQuestion20'
  };
  
  export const installationDetailskeys = {
    INSTALLATION_DETAILS_QUESTION_1: 'installationDetailsQuestion1',
    INSTALLATION_DETAILS_QUESTION_2: 'installationDetailsQuestion2',
    INSTALLATION_DETAILS_QUESTION_3: 'installationDetailsQuestion3',
    INSTALLATION_DETAILS_QUESTION_4: 'installationDetailsQuestion4',
    INSTALLATION_DETAILS_QUESTION_5: 'installationDetailsQuestion5',
    INSTALLATION_DETAILS_QUESTION_6: 'installationDetailsQuestion6',
    INSTALLATION_DETAILS_QUESTION_7: 'installationDetailsQuestion7',
    INSTALLATION_DETAILS_QUESTION_8: 'installationDetailsQuestion8',
    INSTALLATION_DETAILS_QUESTION_9: 'installationDetailsQuestion9',
    INSTALLATION_DETAILS_QUESTION_10: 'installationDetailsQuestion10',
    INSTALLATION_DETAILS_QUESTION_11: 'installationDetailsQuestion11',
    INSTALLATION_DETAILS_QUESTION_12: 'installationDetailsQuestion12',
    INSTALLATION_DETAILS_QUESTION_13: 'installationDetailsQuestion13',
    INSTALLATION_DETAILS_QUESTION_14: 'installationDetailsQuestion14',
    INSTALLATION_DETAILS_QUESTION_15: 'installationDetailsQuestion15',
    INSTALLATION_DETAILS_QUESTION_16: 'installationDetailsQuestion16',
    INSTALLATION_DETAILS_QUESTION_17: 'installationDetailsQuestion17'
  };
  
  export const productClassificationkeys = {
    PRODUCT_CLASSIFICATION_QUESTION_1: 'productClassificationQuestion1',
    PRODUCT_CLASSIFICATION_QUESTION_2: 'productClassificationQuestion2',
    PRODUCT_CLASSIFICATION_QUESTION_3: 'productClassificationQuestion3',
    PRODUCT_CLASSIFICATION_QUESTION_4: 'productClassificationQuestion4',
    PRODUCT_CLASSIFICATION_QUESTION_5: 'productClassificationQuestion5',
    PRODUCT_CLASSIFICATION_QUESTION_6: 'productClassificationQuestion6',
    PRODUCT_CLASSIFICATION_QUESTION_7: 'productClassificationQuestion7',
    PRODUCT_CLASSIFICATION_QUESTION_8: 'productClassificationQuestion8',
    PRODUCT_CLASSIFICATION_QUESTION_9: 'productClassificationQuestion9',
    PRODUCT_CLASSIFICATION_QUESTION_10: 'productClassificationQuestion10',
    PRODUCT_CLASSIFICATION_QUESTION_11: 'productClassificationQuestion11',
    PRODUCT_CLASSIFICATION_QUESTION_12: 'productClassificationQuestion12',
    PRODUCT_CLASSIFICATION_QUESTION_13: 'productClassificationQuestion13',
    PRODUCT_CLASSIFICATION_QUESTION_14: 'productClassificationQuestion14'
  };
  
  export const multiInstallationAndMultiProductMappingkeys = {
    MULTI_INSTALLATION_AND_MULTI_PRODUCT_MAPPING_QUESTION_1: 'multiInstallationAndMultiProductMappingQuestion1',
    MULTI_INSTALLATION_AND_MULTI_PRODUCT_MAPPING_QUESTION_2: 'multiInstallationAndMultiProductMappingQuestion2',
    MULTI_INSTALLATION_AND_MULTI_PRODUCT_MAPPING_QUESTION_3: 'multiInstallationAndMultiProductMappingQuestion3',
    MULTI_INSTALLATION_AND_MULTI_PRODUCT_MAPPING_QUESTION_4: 'multiInstallationAndMultiProductMappingQuestion4',
    MULTI_INSTALLATION_AND_MULTI_PRODUCT_MAPPING_QUESTION_5: 'multiInstallationAndMultiProductMappingQuestion5',
    MULTI_INSTALLATION_AND_MULTI_PRODUCT_MAPPING_QUESTION_6: 'multiInstallationAndMultiProductMappingQuestion6',
    MULTI_INSTALLATION_AND_MULTI_PRODUCT_MAPPING_QUESTION_7: 'multiInstallationAndMultiProductMappingQuestion7',
    MULTI_INSTALLATION_AND_MULTI_PRODUCT_MAPPING_QUESTION_8: 'multiInstallationAndMultiProductMappingQuestion8',
    MULTI_INSTALLATION_AND_MULTI_PRODUCT_MAPPING_QUESTION_9: 'multiInstallationAndMultiProductMappingQuestion9'
  };


  // section 2

  export const productionDataPerProductkeys = {
    PRODUCTION_DATA_PER_PRODUCT_QUESTION_1: 'productionDataPerProductQuestion1',
    PRODUCTION_DATA_PER_PRODUCT_QUESTION_2: 'productionDataPerProductQuestion2',
    PRODUCTION_DATA_PER_PRODUCT_QUESTION_3: 'productionDataPerProductQuestion3',
    PRODUCTION_DATA_PER_PRODUCT_QUESTION_4: 'productionDataPerProductQuestion4',
    PRODUCTION_DATA_PER_PRODUCT_QUESTION_5: 'productionDataPerProductQuestion5',
    PRODUCTION_DATA_PER_PRODUCT_QUESTION_6: 'productionDataPerProductQuestion6',
    PRODUCTION_DATA_PER_PRODUCT_QUESTION_7: 'productionDataPerProductQuestion7',
    PRODUCTION_DATA_PER_PRODUCT_QUESTION_8: 'productionDataPerProductQuestion8',
    PRODUCTION_DATA_PER_PRODUCT_QUESTION_9: 'productionDataPerProductQuestion9',
    PRODUCTION_DATA_PER_PRODUCT_QUESTION_10: 'productionDataPerProductQuestion10',
    PRODUCTION_DATA_PER_PRODUCT_QUESTION_11: 'productionDataPerProductQuestion11',
    PRODUCTION_DATA_PER_PRODUCT_QUESTION_12: 'productionDataPerProductQuestion12'
  };

  export const rawMaterialInputDatakeys = {
    RAW_MATERIAL_INPUT_DATA_QUESTION_1: 'rawMaterialInputDataQuestion1',
    RAW_MATERIAL_INPUT_DATA_QUESTION_2: 'rawMaterialInputDataQuestion2',
    RAW_MATERIAL_INPUT_DATA_QUESTION_3: 'rawMaterialInputDataQuestion3',
    RAW_MATERIAL_INPUT_DATA_QUESTION_4: 'rawMaterialInputDataQuestion4',
    RAW_MATERIAL_INPUT_DATA_QUESTION_5: 'rawMaterialInputDataQuestion5',
    RAW_MATERIAL_INPUT_DATA_QUESTION_6: 'rawMaterialInputDataQuestion6',
    RAW_MATERIAL_INPUT_DATA_QUESTION_7: 'rawMaterialInputDataQuestion7',
    RAW_MATERIAL_INPUT_DATA_QUESTION_8: 'rawMaterialInputDataQuestion8',
    RAW_MATERIAL_INPUT_DATA_QUESTION_9: 'rawMaterialInputDataQuestion9',
    RAW_MATERIAL_INPUT_DATA_QUESTION_10: 'rawMaterialInputDataQuestion10',
    RAW_MATERIAL_INPUT_DATA_QUESTION_11: 'rawMaterialInputDataQuestion11'
  };

  export const fuelConsumptionkeys = {
    FUEL_CONSUMPTION_QUESTION_1: 'fuelConsumptionQuestion1',
    FUEL_CONSUMPTION_QUESTION_2: 'fuelConsumptionQuestion2',
    FUEL_CONSUMPTION_QUESTION_3: 'fuelConsumptionQuestion3',
    FUEL_CONSUMPTION_QUESTION_4: 'fuelConsumptionQuestion4',
    FUEL_CONSUMPTION_QUESTION_5: 'fuelConsumptionQuestion5',
    FUEL_CONSUMPTION_QUESTION_6: 'fuelConsumptionQuestion6',
    FUEL_CONSUMPTION_QUESTION_7: 'fuelConsumptionQuestion7',
    FUEL_CONSUMPTION_QUESTION_8: 'fuelConsumptionQuestion8'
  };

  export const electricityAndHeatDatakeys = {
    ELECTRICITY_AND_HEAT_DATA_QUESTION_1: 'electricityAndHeatDataQuestion1',
    ELECTRICITY_AND_HEAT_DATA_QUESTION_2: 'electricityAndHeatDataQuestion2',
    ELECTRICITY_AND_HEAT_DATA_QUESTION_3: 'electricityAndHeatDataQuestion3',
    ELECTRICITY_AND_HEAT_DATA_QUESTION_4: 'electricityAndHeatDataQuestion4',
    ELECTRICITY_AND_HEAT_DATA_QUESTION_5: 'electricityAndHeatDataQuestion5',
    ELECTRICITY_AND_HEAT_DATA_QUESTION_6: 'electricityAndHeatDataQuestion6'
  };

  // section 3

  export const processEmissionsCalcinationkeys = {
    PROCESS_EMISSIONS_CALCINATION_QUESTION_1: 'processEmissionsCalcinationQuestion1',
    PROCESS_EMISSIONS_CALCINATION_QUESTION_2: 'processEmissionsCalcinationQuestion2',
    PROCESS_EMISSIONS_CALCINATION_QUESTION_3: 'processEmissionsCalcinationQuestion3',
    PROCESS_EMISSIONS_CALCINATION_QUESTION_4: 'processEmissionsCalcinationQuestion4',
    PROCESS_EMISSIONS_CALCINATION_QUESTION_5: 'processEmissionsCalcinationQuestion5',
    PROCESS_EMISSIONS_CALCINATION_QUESTION_6: 'processEmissionsCalcinationQuestion6',
    PROCESS_EMISSIONS_CALCINATION_QUESTION_7: 'processEmissionsCalcinationQuestion7',
    PROCESS_EMISSIONS_CALCINATION_QUESTION_8: 'processEmissionsCalcinationQuestion8',
    PROCESS_EMISSIONS_CALCINATION_QUESTION_9: 'processEmissionsCalcinationQuestion9',
    PROCESS_EMISSIONS_CALCINATION_QUESTION_10: 'processEmissionsCalcinationQuestion10'
  };

  export const combustionEmissionsKilnFuelskeys = {
    COMBUSTION_EMISSIONS_KILN_FUELS_QUESTION_1: 'combustionEmissionsKilnFuelsQuestion1',
    COMBUSTION_EMISSIONS_KILN_FUELS_QUESTION_2: 'combustionEmissionsKilnFuelsQuestion2',
    COMBUSTION_EMISSIONS_KILN_FUELS_QUESTION_3: 'combustionEmissionsKilnFuelsQuestion3',
    COMBUSTION_EMISSIONS_KILN_FUELS_QUESTION_4: 'combustionEmissionsKilnFuelsQuestion4',
    COMBUSTION_EMISSIONS_KILN_FUELS_QUESTION_5: 'combustionEmissionsKilnFuelsQuestion5',
    COMBUSTION_EMISSIONS_KILN_FUELS_QUESTION_6: 'combustionEmissionsKilnFuelsQuestion6',
    COMBUSTION_EMISSIONS_KILN_FUELS_QUESTION_7: 'combustionEmissionsKilnFuelsQuestion7',
    COMBUSTION_EMISSIONS_KILN_FUELS_QUESTION_8: 'combustionEmissionsKilnFuelsQuestion8'
  };

  export const otherProcessEmissionskeys = {
    OTHER_PROCESS_EMISSIONS_QUESTION_1: 'otherProcessEmissionsQuestion1',
    OTHER_PROCESS_EMISSIONS_QUESTION_2: 'otherProcessEmissionsQuestion2',
    OTHER_PROCESS_EMISSIONS_QUESTION_3: 'otherProcessEmissionsQuestion3',
    OTHER_PROCESS_EMISSIONS_QUESTION_4: 'otherProcessEmissionsQuestion4',
    OTHER_PROCESS_EMISSIONS_QUESTION_5: 'otherProcessEmissionsQuestion5',
    OTHER_PROCESS_EMISSIONS_QUESTION_6: 'otherProcessEmissionsQuestion6'
  };

  // section 4

  export const purchasedElectricityKeys = {
    PURCHASED_ELECTRICITY_QUESTION_4_1_1: 'purchasedElectricityQuestion411',
    PURCHASED_ELECTRICITY_QUESTION_4_1_2: 'purchasedElectricityQuestion412',
    PURCHASED_ELECTRICITY_QUESTION_4_1_3: 'purchasedElectricityQuestion413',
    PURCHASED_ELECTRICITY_QUESTION_4_1_4: 'purchasedElectricityQuestion414',
    PURCHASED_ELECTRICITY_QUESTION_4_1_5: 'purchasedElectricityQuestion415',
    PURCHASED_ELECTRICITY_QUESTION_4_1_6: 'purchasedElectricityQuestion416',
    PURCHASED_ELECTRICITY_QUESTION_4_1_7: 'purchasedElectricityQuestion417',
    PURCHASED_ELECTRICITY_QUESTION_4_1_8: 'purchasedElectricityQuestion418',
    PURCHASED_ELECTRICITY_QUESTION_4_1_9: 'purchasedElectricityQuestion419',
    PURCHASED_ELECTRICITY_QUESTION_4_1_10: 'purchasedElectricityQuestion4110',
    PURCHASED_ELECTRICITY_QUESTION_4_1_11: 'purchasedElectricityQuestion4111',
    PURCHASED_ELECTRICITY_QUESTION_4_1_12: 'purchasedElectricityQuestion4112',
    PURCHASED_ELECTRICITY_QUESTION_4_1_13: 'purchasedElectricityQuestion4113',
    PURCHASED_ELECTRICITY_QUESTION_4_1_14: 'purchasedElectricityQuestion4114',
    PURCHASED_ELECTRICITY_QUESTION_4_1_15: 'purchasedElectricityQuestion4115'
  };

  export const captiveElectricityKeys = {
    CAPTIVE_ELECTRICITY_QUESTION_4_2_1: 'captiveElectricityQuestion421',
    CAPTIVE_ELECTRICITY_QUESTION_4_2_2: 'captiveElectricityQuestion422',
    CAPTIVE_ELECTRICITY_QUESTION_4_2_3: 'captiveElectricityQuestion423',
    CAPTIVE_ELECTRICITY_QUESTION_4_2_4: 'captiveElectricityQuestion424',
    CAPTIVE_ELECTRICITY_QUESTION_4_2_5: 'captiveElectricityQuestion425',
    CAPTIVE_ELECTRICITY_QUESTION_4_2_6: 'captiveElectricityQuestion426',
    CAPTIVE_ELECTRICITY_QUESTION_4_2_7: 'captiveElectricityQuestion427',
    CAPTIVE_ELECTRICITY_QUESTION_4_2_8: 'captiveElectricityQuestion428',
    CAPTIVE_ELECTRICITY_QUESTION_4_2_9: 'captiveElectricityQuestion429',
    CAPTIVE_ELECTRICITY_QUESTION_4_2_10: 'captiveElectricityQuestion4210'
  };

  export const heatSteamConsumptionKeys = {
    HEAT_STEAM_QUESTION_4_3_1: 'heatSteamQuestion431',
    HEAT_STEAM_QUESTION_4_3_2: 'heatSteamQuestion432',
    HEAT_STEAM_QUESTION_4_3_3: 'heatSteamQuestion433',
    HEAT_STEAM_QUESTION_4_3_4: 'heatSteamQuestion434',
    HEAT_STEAM_QUESTION_4_3_5: 'heatSteamQuestion435',
    HEAT_STEAM_QUESTION_4_3_6: 'heatSteamQuestion436'
  };

  // section 5

  export const clinkerUsedAsPrecursorInCementKeys = {
    CLINKER_USED_AS_PRECURSOR_IN_CEMENT_QUESTION_5_1_1: 'clinkerUsedAsPrecursorInCementQuestion511',
    CLINKER_USED_AS_PRECURSOR_IN_CEMENT_QUESTION_5_1_2: 'clinkerUsedAsPrecursorInCementQuestion512',
    CLINKER_USED_AS_PRECURSOR_IN_CEMENT_QUESTION_5_1_3: 'clinkerUsedAsPrecursorInCementQuestion513',
    CLINKER_USED_AS_PRECURSOR_IN_CEMENT_QUESTION_5_1_4: 'clinkerUsedAsPrecursorInCementQuestion514',
    CLINKER_USED_AS_PRECURSOR_IN_CEMENT_QUESTION_5_1_5: 'clinkerUsedAsPrecursorInCementQuestion515',
    CLINKER_USED_AS_PRECURSOR_IN_CEMENT_QUESTION_5_1_6: 'clinkerUsedAsPrecursorInCementQuestion516',
    CLINKER_USED_AS_PRECURSOR_IN_CEMENT_QUESTION_5_1_7: 'clinkerUsedAsPrecursorInCementQuestion517',
    CLINKER_USED_AS_PRECURSOR_IN_CEMENT_QUESTION_5_1_8: 'clinkerUsedAsPrecursorInCementQuestion518',
    CLINKER_USED_AS_PRECURSOR_IN_CEMENT_QUESTION_5_1_9: 'clinkerUsedAsPrecursorInCementQuestion519',
    CLINKER_USED_AS_PRECURSOR_IN_CEMENT_QUESTION_5_1_10: 'clinkerUsedAsPrecursorInCementQuestion5110'
  };

  export const precursorInputKeys = {
    PRECURSOR_INPUT_QUESTION_5_2_1: 'precursorInputQuestion521',
    PRECURSOR_INPUT_QUESTION_5_2_2: 'precursorInputQuestion522',
    PRECURSOR_INPUT_QUESTION_5_2_3: 'precursorInputQuestion523',
    PRECURSOR_INPUT_QUESTION_5_2_4: 'precursorInputQuestion524',
    PRECURSOR_INPUT_QUESTION_5_2_5: 'precursorInputQuestion525',
    PRECURSOR_INPUT_QUESTION_5_2_6: 'precursorInputQuestion526',
    PRECURSOR_INPUT_QUESTION_5_2_7: 'precursorInputQuestion527',
    PRECURSOR_INPUT_QUESTION_5_2_8: 'precursorInputQuestion528',
    PRECURSOR_INPUT_QUESTION_5_2_9: 'precursorInputQuestion529',
    PRECURSOR_INPUT_QUESTION_5_2_10: 'precursorInputQuestion5210',
    PRECURSOR_INPUT_QUESTION_5_2_11: 'precursorInputQuestion5211',
    PRECURSOR_INPUT_QUESTION_5_2_12: 'precursorInputQuestion5212',
    PRECURSOR_INPUT_QUESTION_5_2_13: 'precursorInputQuestion5213',
    PRECURSOR_INPUT_QUESTION_5_2_14: 'precursorInputQuestion5214',
    PRECURSOR_INPUT_QUESTION_5_2_15: 'precursorInputQuestion5215',
    PRECURSOR_INPUT_QUESTION_5_2_16: 'precursorInputQuestion5216',
    PRECURSOR_INPUT_QUESTION_5_2_17: 'precursorInputQuestion5217',
    PRECURSOR_INPUT_QUESTION_5_2_18: 'precursorInputQuestion5218',
    PRECURSOR_INPUT_QUESTION_5_2_19: 'precursorInputQuestion5219',
    PRECURSOR_INPUT_QUESTION_5_2_20: 'precursorInputQuestion5220'
  };

  // section 6

  export const methodologySelectionKeys = {
    METHODOLOGY_SELECTION_QUESTION_6_1_1: 'methodologySelectionQuestion611',
    METHODOLOGY_SELECTION_QUESTION_6_1_2: 'methodologySelectionQuestion612',
    METHODOLOGY_SELECTION_QUESTION_6_1_3: 'methodologySelectionQuestion613',
    METHODOLOGY_SELECTION_QUESTION_6_1_4: 'methodologySelectionQuestion614',
    METHODOLOGY_SELECTION_QUESTION_6_1_5: 'methodologySelectionQuestion615',
    METHODOLOGY_SELECTION_QUESTION_6_1_6: 'methodologySelectionQuestion616',
    METHODOLOGY_SELECTION_QUESTION_6_1_7: 'methodologySelectionQuestion617',
    METHODOLOGY_SELECTION_QUESTION_6_1_8: 'methodologySelectionQuestion618',
    METHODOLOGY_SELECTION_QUESTION_6_1_9: 'methodologySelectionQuestion619'
  };

  export const dataQualityLevelsKeys = {
    DATA_QUALITY_LEVELS_QUESTION_6_2_1: 'dataQualityLevelsQuestion621',
    DATA_QUALITY_LEVELS_QUESTION_6_2_2: 'dataQualityLevelsQuestion622',
    DATA_QUALITY_LEVELS_QUESTION_6_2_3: 'dataQualityLevelsQuestion623',
    DATA_QUALITY_LEVELS_QUESTION_6_2_4: 'dataQualityLevelsQuestion624',
    DATA_QUALITY_LEVELS_QUESTION_6_2_5: 'dataQualityLevelsQuestion625',
    DATA_QUALITY_LEVELS_QUESTION_6_2_6: 'dataQualityLevelsQuestion626',
    DATA_QUALITY_LEVELS_QUESTION_6_2_7: 'dataQualityLevelsQuestion627',
    DATA_QUALITY_LEVELS_QUESTION_6_2_8: 'dataQualityLevelsQuestion628',
    DATA_QUALITY_LEVELS_QUESTION_6_2_9: 'dataQualityLevelsQuestion629',
    DATA_QUALITY_LEVELS_QUESTION_6_2_10: 'dataQualityLevelsQuestion6210',
    DATA_QUALITY_LEVELS_QUESTION_6_2_11: 'dataQualityLevelsQuestion6211'
  };

  export const thirdPartyVerificationKeys = {
    THIRD_PARTY_VERIFICATION_QUESTION_6_3_1: 'thirdPartyVerificationQuestion631',
    THIRD_PARTY_VERIFICATION_QUESTION_6_3_2: 'thirdPartyVerificationQuestion632',
    THIRD_PARTY_VERIFICATION_QUESTION_6_3_3: 'thirdPartyVerificationQuestion633',
    THIRD_PARTY_VERIFICATION_QUESTION_6_3_4: 'thirdPartyVerificationQuestion634',
    THIRD_PARTY_VERIFICATION_QUESTION_6_3_5: 'thirdPartyVerificationQuestion635',
    THIRD_PARTY_VERIFICATION_QUESTION_6_3_6: 'thirdPartyVerificationQuestion636',
    THIRD_PARTY_VERIFICATION_QUESTION_6_3_7: 'thirdPartyVerificationQuestion637',
    THIRD_PARTY_VERIFICATION_QUESTION_6_3_8: 'thirdPartyVerificationQuestion638',
    THIRD_PARTY_VERIFICATION_QUESTION_6_3_9: 'thirdPartyVerificationQuestion639',
    THIRD_PARTY_VERIFICATION_QUESTION_6_3_10: 'thirdPartyVerificationQuestion6310',
    THIRD_PARTY_VERIFICATION_QUESTION_6_3_11: 'thirdPartyVerificationQuestion6311'
  };

  // section 7

  export const productLevelEmissionSummaryKeys = {
    PRODUCT_LEVEL_EMISSION_SUMMARY_QUESTION_7_1_1: 'productLevelEmissionSummaryQuestion711',
    PRODUCT_LEVEL_EMISSION_SUMMARY_QUESTION_7_1_2: 'productLevelEmissionSummaryQuestion712',
    PRODUCT_LEVEL_EMISSION_SUMMARY_QUESTION_7_1_3: 'productLevelEmissionSummaryQuestion713',
    PRODUCT_LEVEL_EMISSION_SUMMARY_QUESTION_7_1_4: 'productLevelEmissionSummaryQuestion714',
    PRODUCT_LEVEL_EMISSION_SUMMARY_QUESTION_7_1_5: 'productLevelEmissionSummaryQuestion715',
    PRODUCT_LEVEL_EMISSION_SUMMARY_QUESTION_7_1_6: 'productLevelEmissionSummaryQuestion716',
    PRODUCT_LEVEL_EMISSION_SUMMARY_QUESTION_7_1_7: 'productLevelEmissionSummaryQuestion717',
    PRODUCT_LEVEL_EMISSION_SUMMARY_QUESTION_7_1_8: 'productLevelEmissionSummaryQuestion718',
    PRODUCT_LEVEL_EMISSION_SUMMARY_QUESTION_7_1_9: 'productLevelEmissionSummaryQuestion719',
    PRODUCT_LEVEL_EMISSION_SUMMARY_QUESTION_7_1_10: 'productLevelEmissionSummaryQuestion7110'
  };

  export const exportBatchEmissionAssignmentKeys = {
    EXPORT_BATCH_EMISSION_ASSIGNMENT_QUESTION_7_2_1: 'exportBatchEmissionAssignmentQuestion721',
    EXPORT_BATCH_EMISSION_ASSIGNMENT_QUESTION_7_2_2: 'exportBatchEmissionAssignmentQuestion722',
    EXPORT_BATCH_EMISSION_ASSIGNMENT_QUESTION_7_2_3: 'exportBatchEmissionAssignmentQuestion723',
    EXPORT_BATCH_EMISSION_ASSIGNMENT_QUESTION_7_2_4: 'exportBatchEmissionAssignmentQuestion724',
    EXPORT_BATCH_EMISSION_ASSIGNMENT_QUESTION_7_2_5: 'exportBatchEmissionAssignmentQuestion725',
    EXPORT_BATCH_EMISSION_ASSIGNMENT_QUESTION_7_2_6: 'exportBatchEmissionAssignmentQuestion726',
    EXPORT_BATCH_EMISSION_ASSIGNMENT_QUESTION_7_2_7: 'exportBatchEmissionAssignmentQuestion727',
    EXPORT_BATCH_EMISSION_ASSIGNMENT_QUESTION_7_2_8: 'exportBatchEmissionAssignmentQuestion728',
    EXPORT_BATCH_EMISSION_ASSIGNMENT_QUESTION_7_2_9: 'exportBatchEmissionAssignmentQuestion729',
    EXPORT_BATCH_EMISSION_ASSIGNMENT_QUESTION_7_2_10: 'exportBatchEmissionAssignmentQuestion7210'
  };

  export const documentAttachmentsKeys = {
    DOCUMENT_ATTACHMENTS_QUESTION_7_3_1: 'documentAttachmentsQuestion731',
    DOCUMENT_ATTACHMENTS_QUESTION_7_3_2: 'documentAttachmentsQuestion732',
    DOCUMENT_ATTACHMENTS_QUESTION_7_3_3: 'documentAttachmentsQuestion733',
    DOCUMENT_ATTACHMENTS_QUESTION_7_3_4: 'documentAttachmentsQuestion734',
    DOCUMENT_ATTACHMENTS_QUESTION_7_3_5: 'documentAttachmentsQuestion735',
    DOCUMENT_ATTACHMENTS_QUESTION_7_3_6: 'documentAttachmentsQuestion736',
    DOCUMENT_ATTACHMENTS_QUESTION_7_3_7: 'documentAttachmentsQuestion737',
    DOCUMENT_ATTACHMENTS_QUESTION_7_3_8: 'documentAttachmentsQuestion738',
    DOCUMENT_ATTACHMENTS_QUESTION_7_3_9: 'documentAttachmentsQuestion739',
    DOCUMENT_ATTACHMENTS_QUESTION_7_3_10: 'documentAttachmentsQuestion7310',
    DOCUMENT_ATTACHMENTS_QUESTION_7_3_11: 'documentAttachmentsQuestion7311'
  };